
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.542 17.993L35.47 3.06a1.78 1.78 0 00.393-1.952 1.78 1.78 0 00-.393-.58 1.788 1.788 0 00-1.96-.39c-.218.09-.416.223-.582.39L18 15.445 3.073.529a1.787 1.787 0 00-1.96-.392C.895.228.697.361.531.53A1.779 1.779 0 00.138 2.48c.091.217.225.414.393.58l14.927 14.933L.53 32.926a1.78 1.78 0 00-.393 1.952c.091.217.225.414.393.58.345.361.799.542 1.271.542.454 0 .908-.18 1.271-.542L18 20.542l14.927 14.916c.345.361.799.542 1.27.542.455 0 .909-.18 1.272-.542a1.779 1.779 0 00.393-1.952 1.78 1.78 0 00-.393-.58L20.542 17.993z","fill":"#e463a0"}})])
          )
        }
      }
    